import { FETCH_STATIC_PAGES } from "./actionTypes";
import instance from "./instance";

export const fetchStaticPages = () => {
  return async (dispatch, getState) => {
    try {
      const res = await instance.get("/fetch_static_pages/");

      if (res.data.success) {
        dispatch({ type: FETCH_STATIC_PAGES, payload: res.data.pages });
        return true;
      }
      return false;
    } catch (err) {
      console.error(err);
      return false;
    }
  };
};
